import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DeskDashboardPanel } from '@/components/DeskDashboard';
import { useCMSLoyaltyProgram } from '@/modules/loyaltyNew/hooks/useCMSLoyaltyProgram';
import { useGetCommonStore } from '@/store';
import { LoyaltyProgramIcon } from './LoyaltyProgramIcon';
import { LoyaltyProgramPopup } from './LoyaltyProgramPopup';

export const LoyaltyProgramSection: FC = () => {
  const { t } = useTranslation();

  const { data } = useCMSLoyaltyProgram();

  const useCommonStore = useGetCommonStore();
  const loyaltySseState = useCommonStore.use.loyaltySseState();
  const level = loyaltySseState?.level ?? null;

  const labelText = useMemo(
    () => (level ? `${t('loyalty.lvl')}: ${level.number}` : ''),
    [level, t]
  );

  const currentLevelData = useMemo(
    () => (level ? data?.levels[level.number - 1] : undefined),
    [data?.levels, level]
  );

  if (!(level && currentLevelData)) return null;

  return (
    <DeskDashboardPanel
      icon={<LoyaltyProgramIcon level={currentLevelData} />}
      labelText={labelText}
      popupContent={(closePopup) => (
        <LoyaltyProgramPopup onLinkClick={closePopup} />
      )}
    />
  );
};
